import React from 'react';
import {Link as RouterLink, useNavigate} from "react-router-dom";
import {useAuth} from "./auth/AuthProvider";
import { CgDarkMode } from "react-icons/cg";
import {useTheme} from "@heroui/use-theme";
import { Icon } from "@iconify/react";

import {
    Navbar,
    NavbarBrand,
    NavbarContent,
    NavbarItem,
    Button,
    NavbarMenuToggle,
    NavbarMenuItem,
    NavbarMenu,
    Link as NextUILink,
    DropdownTrigger,
    Avatar,
    Dropdown,
    DropdownMenu, DropdownItem, Image
} from "@heroui/react";

export const AcmeLogo = () => {
    return (
        <svg fill="none" height="36" viewBox="0 0 32 32" width="36">
            <path
                clipRule="evenodd"
                d="M17.6482 10.1305L15.8785 7.02583L7.02979 22.5499H10.5278L17.6482 10.1305ZM19.8798 14.0457L18.11 17.1983L19.394 19.4511H16.8453L15.1056 22.5499H24.7272L19.8798 14.0457Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export const RSKLogo = () => {
    return (
        <img src={process.env.PUBLIC_URL + "/QuickViewR.png"} alt="Acme Logo" width="150" height="40" />
    )
}

const NavBar = ({ darkMode, setDarkMode, selectedMenu, setSelectedMenu }) => {
    const navigate = useNavigate();
    const { tokenExists, logout, userProfile, loadingProfile } = useAuth();
    const { theme, setTheme } = useTheme()
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const toggleDarkMode = () => {
        setDarkMode(!darkMode);
        setTheme(darkMode ? 'light' : 'dark'); // Toggle theme based on darkMode state

        console.log("userProfile", userProfile)
    };

    const handleLoginOutBtn = () => {
        if (tokenExists()) {
            logout();
        } else {
            navigate("/login");
        }
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const menuItems = [
        { name: "Claims", href: "/", mainMenu: true },
        { name: "Maestra", href: "/maestra", mainMenu: true},
        { name: "Usuarios", href: "/usuarios", mainMenu: true},
        { name: "Chat", href: "/chat", mainMenu: true},
        { name: "Integrations", href: "#", mainMenu: true},
        { name: "My Settings", href: "#", mainMenu: false},
        { name: "Log Out/Log In", href: "#", mainMenu: false}
    ];

    return (
        <Navbar onMenuOpenChange={setIsMenuOpen}>
            <NavbarMenuToggle
                aria-label={isMenuOpen ? "Close menu" : "Open menu"}
                className="sm:hidden"
            />
            <NavbarBrand>
                <div className="flex gap-1 justify-center items-center" >
                    <RSKLogo />
                    <Image
                        src= {process.env.PUBLIC_URL + "/PoweredBy.png"}
                        className="max-w-[55px] max-h-[30px] object-contain"
                        width={55}
                        height={30}
                        alt="AWS Logo"
                    />
                </div>
            </NavbarBrand>

            <NavbarContent className="hidden sm:flex gap-4" justify="center">
            {menuItems.map((item, index) => (
                <NavbarItem key={index} isActive={selectedMenu === item.name} hidden={!item.mainMenu}>
                    <NextUILink
                        as={RouterLink}
                        color={ selectedMenu === item.name ? "primary" : "foreground" }
                        to={item.href}
                    >
                        {item.name}
                    </NextUILink>
                </NavbarItem>
            ))}
            </NavbarContent>

            <NavbarContent justify="end">
                {/* <NavbarItem>
                    <Button
                        color={tokenExists() ? "secondary" : "primary"}
                        variant="light"
                        onPress={handleLoginOutBtn}
                    >
                        {tokenExists() ? "Logout" : "Login"}
                    </Button>
                </NavbarItem> */}
                <NavbarItem>
                    <Button
                        isIconOnly
                        onPress={toggleDarkMode}
                        aria-label="Toggle Dark Mode"
                        className="transition-all duration-300 hover:scale-110"
                        style={{ background: 'transparent', border: 'none', boxShadow: 'none', padding: 0 }}
                    >
                        <Icon
                            icon={theme === "light" ? "solar:moon-stars-bold-duotone" : "solar:sun-2-bold-duotone"}
                            width={28}
                            height={28}
                            className={theme === "light" ? "text-blue-700" : "text-yellow-400"}
                        />
                    </Button>
                </NavbarItem>


                <Dropdown placement="bottom-end">
                    <DropdownTrigger>
                        <Avatar
                            isBordered
                            as="button"
                            className="transition-transform"
                            color="secondary"
                            name={
                                loadingProfile
                                    ? "Loading..."
                                    : userProfile?.first_name && userProfile?.last_name
                                        ? `${userProfile.first_name.charAt(0).toUpperCase()}${userProfile.last_name.charAt(0).toUpperCase()}` // Mostrar la inicial del nombre completo
                                        : "N/A"
                            }
                            size="sm"
                            src={userProfile?.avatar} // Usar avatar si está disponible
                        />
                    </DropdownTrigger>
                    <DropdownMenu aria-label="Profile Actions" variant="flat">
                        <DropdownItem key="profile" className="h-14 gap-2">
                            <p className="font-semibold">
                                {loadingProfile
                                    ? "Loading profile..."
                                    : userProfile
                                        ? `Signed in as ${userProfile.name}`
                                        : "Not signed in"}
                            </p>
                            <p className="font-semibold">
                                {userProfile?.email || "no email available"}
                            </p>
                        </DropdownItem>
                        <DropdownItem key="settings">My Settings</DropdownItem>
                        {tokenExists() && (
                            <DropdownItem key="logout" color="danger" onPress={logout}>
                                Log Out
                            </DropdownItem>
                        )}
                    </DropdownMenu>
                </Dropdown>
            </NavbarContent>

            <NavbarMenu>
                {menuItems.map((item, index) => (
                    <NavbarMenuItem key={`${item}-${index}`} isActive={selectedMenu === item.name}>
                        <NextUILink
                            as={RouterLink}
                            color={
                                index === 2 ? "primary" : index === menuItems.length - 1 ? "danger" : "foreground"
                            }
                            to={item.href}>
                            {item.name}
                        </NextUILink>
                    </NavbarMenuItem>
                ))}
            </NavbarMenu>
        </Navbar>
    );
}

export default NavBar